import Chip from "@material-ui/core/Chip"
import { makeStyles } from '@material-ui/core/styles';
import React from "react";

const useStyles = makeStyles({
  root: {
    marginRight: '10px'
  }
})

export function Tag(props) {
  const classes = useStyles();

    if(props.oneSimulation) {
      return <Chip className={classes.root} label={props.name} onClick={()=>props.showAllTags()}/>
    }  else if(props.deletable){
      return <Chip className={classes.root} label={props.name} onDelete={() => props.onDelete()}/>
    } else {
      return <Chip className={classes.root} label={props.name}/>
    }
}
